/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_Onboarding_Motivation_Intro_AlertInputs */

const en_register_onboarding_motivation_intro_alert = /** @type {(inputs: Register_Onboarding_Motivation_Intro_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Now enter your motivation for the other selected positions:`)
};

const de_register_onboarding_motivation_intro_alert = /** @type {(inputs: Register_Onboarding_Motivation_Intro_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib nun deine Motivation für die weiteren ausgewählten Positionen ein:`)
};

/**
* | output |
* | --- |
* | "Now enter your motivation for the other selected positions:" |
*
* @param {Register_Onboarding_Motivation_Intro_AlertInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const register_onboarding_motivation_intro_alert = /** @type {((inputs?: Register_Onboarding_Motivation_Intro_AlertInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Motivation_Intro_AlertInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_motivation_intro_alert(inputs)
	return en_register_onboarding_motivation_intro_alert(inputs)
});